import { gql } from 'apollo-angular';

export const mutationMatch = gql`
  mutation validateMatchWithCode($matchID: String, $key: String, $code: String) {
    ValidateMatchWithCode(matchID: $matchID, key: $key, code: $code)
  }
`;

export const mutationValidateMatch = gql`
  mutation validateMatch($matchID: String) {
    ValidateMatch(matchID: $matchID)
  }
`;

export const queryMatches = gql`
  query getMatches($ownerID: String) {
     Matches(ownerID: $ownerID) {
      owner{
        firstName
        lastName
        gender
      }
      tester{
        firstName
        lastName
        gender
      }
      status
      nbSales
      salesDeniedDefinitely
      _{
        created
      }
    }
  }
`;

export const queryMatch = gql`
  query getMatch($ID: String) {
     Match(ID: $ID) {
      ID
      ownerID
      owner{
        firstName
        lastName
        gender
        email
        phone
        productIDs
        status
      }
      tester{
        firstName
        lastName
        gender
        email
        phone
      }
      status
      nbSales
      salesDeniedDefinitely
      challengeSales{
        isEnabled
        incentive
        points
        devise
        commentEnabled
        commentLabel
        checkboxEnabled
        checkboxLabel
        optionalsMediasEnabled
        optionalsMediasType
        optionalsMediasMax
        ambassadorsStatus
        products
        levels            
        startDate
        endDate
        externalTarget{
          externalDataTargetID
        }
      }
    }
  }
`;

export const mutationValidateMatchWithCode = gql`
  mutation validateMatchWithCode($code: String) {
    ValidateMatchWithCode(code: $code)
  }
`;
